import React, { useState } from 'react'
import IconCheckBox from "./icon-checkbox"
import { ExpireIcon, BadWorkIcon, RubleIcon, RetryIcon, WarrantyIcon, NotWarrantyIcon, PossWarrantyIcon, UrgentIcon, ToolIcon, ResetIcon } from '../resource/icons'

export default function MarksPanel(props) {
  
  let handleChange = e => {}

  return (
    <div>
      { props.marks.immediate &&
      <IconCheckBox icon={<UrgentIcon />}
        value={props.marksValue.immediate}
        onChange={props.onChangeImmediate || handleChange }
      >
        Аварийная
      </IconCheckBox> }
       
       <div style={{marginTop:10}} /> 

      { props.marks.chargeable &&
      <IconCheckBox icon={<RubleIcon />}
        value={props.marksValue.chargeable}
        onChange={props.onChangeChargeable || handleChange }
      >
        Платная
      </IconCheckBox> }

      <div style={{marginTop:10}} />

      { !props.marks.byClient &&
      <IconCheckBox icon={<ToolIcon />}
        value={props.marksValue.internal}
        onChange={props.onChangeInternal || handleChange }
      >
        Внутренняя
      </IconCheckBox> }

     {/* <IconCheckBox icon={<PossWarrantyIcon />}
        value={props.marks.possWarranty}
        onChange={props.onChangePossWarranty || handleChange }
      >
        Возможно гарантия
  </IconCheckBox> */}

    </div>
  );
}